import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import firebaseApp from "../fireconnect";
import { Button, Modal } from "react-bootstrap";
import Switch from "@mui/material/Switch";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ContactFormData = () => {
  const [submissions, setSubmissions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedSubmission, setSelectedSubmission] = useState(null);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [submissionIdToDelete, setSubmissionIdToDelete] = useState(null);

  useEffect(() => {
    getSubmissionData();
  }, []);

  const getSubmissionData = () => {
    const db = firebaseApp.firestore();
    db.collection("ContactFormSubmissions")
      .get()
      .then((querySnapshot) => {
        let submissionsData = [];
        querySnapshot.forEach((doc) => {
          submissionsData.push({ ...doc.data(), id: doc.id });
        });
        setSubmissions(submissionsData);
      });
  };

  const handleViewSubmission = (submissionId) => {
    const submission = submissions.find((sub) => sub.id === submissionId);
    setSelectedSubmission(submission);
    setShowModal(true);
  };

  const handleInquiryStatusChange = (submissionId, checked) => {
    setSubmissions((prevSubmissions) =>
      prevSubmissions.map((sub) =>
        sub.id === submissionId ? { ...sub, inquiryStatus: checked } : sub
      )
    );

    const db = firebaseApp.firestore();
    db.collection("ContactFormSubmissions")
      .doc(submissionId)
      .update({ inquiryStatus: checked })
      .catch((error) => {
        toast.error("Failed to update status.", {
          position: "top-right",
          autoClose: 3000,
        });
      });
  };

  const handleDeleteSubmission = (submissionId) => {
    setSubmissionIdToDelete(submissionId);
    setConfirmDeleteOpen(true);
  };

  const confirmDelete = async () => {
    try {
      const db = firebaseApp.firestore();
      await db
        .collection("ContactFormSubmissions")
        .doc(submissionIdToDelete)
        .delete();

      setSubmissions((prev) =>
        prev.filter((sub) => sub.id !== submissionIdToDelete)
      );

      toast.success("Inquiry deleted successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      setConfirmDeleteOpen(false);
      setSubmissionIdToDelete(null);
    } catch (error) {
      console.error("Error deleting inquiry:", error);
      toast.error("Failed to delete inquiry.", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  const columns = [
    {
      name: "fullName",
      label: "Full Name",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <div className="d-flex justify-content-center">{value}</div>
        ),
      },
    },
    {
      name: "phone",
      label: "Phone Number",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <div className="d-flex justify-content-center">{value}</div>
        ),
      },
    },
    {
      name: "message",
      label: "Message",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          const maxLength = 50;
          const trimmed =
            value && value.length > maxLength
              ? value.substring(0, maxLength) + "..."
              : value;
          return <div className="d-flex justify-content-center">{trimmed}</div>;
        },
      },
    },
    {
      name: "createdAt",
      label: "Submitted Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          const date = new Date(value.seconds * 1000).toLocaleString();
          return <div className="d-flex justify-content-center">{date}</div>;
        },
      },
    },
    {
      name: "inquiryStatus",
      label: "Inquiry Status",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => (
          <div className="d-flex justify-content-center">
            <Switch
              checked={value}
              onChange={(e) => {
                const checked = e.target.checked;
                const submissionId = tableMeta.rowData[5];
                handleInquiryStatusChange(submissionId, checked);
              }}
            />
          </div>
        ),
      },
    },
    {
      name: "id",
      label: "View Details",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => (
          <div className="d-flex justify-content-center">
            <Button
              variant="secondary"
              onClick={() => handleViewSubmission(value)}
            >
              <i className="bi bi-eye-fill"></i>
            </Button>
          </div>
        ),
      },
    },
    {
      name: "id",
      label: "Delete",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => (
          <div className="d-flex justify-content-center">
            <Button
              variant="danger"
              size="sm"
              onClick={() => handleDeleteSubmission(value)}
            >
              <i className="bi bi-trash3-fill"></i>
            </Button>
          </div>
        ),
      },
    },
  ];

  return (
    <div>
      <h4 className="mb-2">Contact Form Data</h4>
      <MUIDataTable
        data={submissions}
        columns={columns}
        options={{
          tableBodyHeight: "57vh",
          responsive: "standard",
          selectableRows: "none",
        }}
      />

      {selectedSubmission && (
        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Contact Form Data</Modal.Title>
          </Modal.Header>
          <Modal.Body className="h-auto">
            <div>
              <strong>Full Name:</strong> {selectedSubmission.fullName}
            </div>
            <div>
              <strong>Phone Number:</strong> {selectedSubmission.phone}
            </div>
            <div>
              <strong>Message:</strong> {selectedSubmission.message}
            </div>
            <div>
              <strong>Submitted Date:</strong>{" "}
              {new Date(
                selectedSubmission.createdAt.seconds * 1000
              ).toLocaleString()}
            </div>
            <div>
              <strong>Inquiry Status:</strong>{" "}
              {selectedSubmission.inquiryStatus ? "Done" : "Pending"}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      <Dialog
        open={confirmDeleteOpen}
        onClose={() => setConfirmDeleteOpen(false)}
      >
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <p>Are you sure you want to delete this inquiry?</p>
        </DialogContent>
        <DialogActions>
          <Button
            variant="secondary"
            onClick={() => setConfirmDeleteOpen(false)}
          >
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <ToastContainer />
    </div>
  );
};

export default ContactFormData;
